import { Instagram, Youtube, MessageCircle } from "lucide-react";
import { useLang } from "../../lib/lang";
import { LINKS, waLink } from "../../lib/content";
import { LogoMark } from "./Logo";
import { TikTokIcon } from "./Order";
import { Reveal } from "./Reveal";

export const Footer = () => {
  const { t } = useLang();
  const socials = [
    { k: "whatsapp", href: waLink(t.waGreeting), Icon: MessageCircle },
    { k: "instagram", href: LINKS.instagram, Icon: Instagram },
    { k: "tiktok", href: LINKS.tiktok, Icon: TikTokIcon },
    { k: "youtube", href: LINKS.youtube, Icon: Youtube },
  ];
  return (
    <footer className="relative border-t border-white/10 bg-[#080A15] overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 pt-20 pb-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <LogoMark className="w-14 h-14 mb-6" />
            <p className="font-script text-3xl text-sky-300">{t.footerLine}</p>
          </div>
          <div className="flex gap-3">
            {socials.map(({ k, href, Icon }) => (
              <a key={k} href={href} target="_blank" rel="noreferrer" data-testid={`footer-social-${k}`} aria-label={k} className="grid place-items-center w-12 h-12 rounded-full border border-white/15 text-white hover:bg-white hover:text-[#0B0E1B] transition-colors duration-300">
                <Icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
        <Reveal y={60}>
          <p className="font-display uppercase text-[17vw] lg:text-[13.5vw] xl:text-[200px] leading-[0.8] tracking-[-0.04em] text-outline-violet mt-16 select-none whitespace-nowrap">Vinslab</p>
        </Reveal>
        <div className="mt-10 flex flex-col sm:flex-row justify-between gap-2 font-mono text-xs text-slate-400">
          <span>© {new Date().getFullYear()} Vinslab Maker · 3D Printing Studio. {t.rights}</span>
          <span>Create. Print. Make It Real.</span>
        </div>
      </div>
    </footer>
  );
};
